import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon, UsersIcon, BriefcaseIcon, Activity } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

export function AdminPanel() {
  const navigate = useNavigate();
  const { profile } = useAuth();

  if (!profile || profile.role !== 'admin') {
    return (
      <div className="min-h-screen bg-[#F5F5F5] flex items-center justify-center p-6">
        <div className="bg-white rounded-2xl shadow-sm p-8 text-center max-w-md">
          <p className="text-lg font-semibold text-gray-800 mb-2">Access Denied</p>
          <p className="text-gray-600 mb-6">You need admin privileges to access this page.</p>
          <button
            onClick={() => navigate('/dashboard')}
            className="bg-[#5B8E87] text-white px-6 py-3 rounded-xl font-medium"
          >
            Back to Dashboard
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#F5F5F5]">
      {/* Header */}
      <div className="bg-white shadow-sm sticky top-0 z-30">
        <div className="p-4">
          <div className="flex items-center gap-3 mb-3">
            <button onClick={() => navigate('/dashboard')} className="text-gray-600 hover:text-gray-800">
              <ArrowLeftIcon className="w-6 h-6" />
            </button>
            <h1 className="text-xl font-semibold text-[#212121]">Admin Panel</h1>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="p-6 max-w-4xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* User Management Card */}
          <button
            onClick={() => navigate('/admin/users')}
            className="bg-white rounded-2xl shadow-sm p-6 text-left hover:shadow-md transition-shadow"
          >
            <div className="w-12 h-12 bg-[#5B8E87] bg-opacity-10 rounded-xl flex items-center justify-center mb-4">
              <UsersIcon className="w-6 h-6 text-[#5B8E87]" />
            </div>
            <h2 className="text-lg font-semibold text-[#212121] mb-2">User Management</h2>
            <p className="text-sm text-gray-600">
              Create and manage practitioner accounts, assign roles and professions
            </p>
          </button>

          {/* Profession Management Card */}
          <button
            onClick={() => navigate('/admin/professions')}
            className="bg-white rounded-2xl shadow-sm p-6 text-left hover:shadow-md transition-shadow"
          >
            <div className="w-12 h-12 bg-[#4ECDC4] bg-opacity-10 rounded-xl flex items-center justify-center mb-4">
              <BriefcaseIcon className="w-6 h-6 text-[#4ECDC4]" />
            </div>
            <h2 className="text-lg font-semibold text-[#212121] mb-2">Profession Management</h2>
            <p className="text-sm text-gray-600">
              Configure profession types, tab visibility, and custom labels
            </p>
          </button>

          {/* System Monitor Card */}
          <button
            onClick={() => navigate('/admin/monitor')}
            className="bg-white rounded-2xl shadow-sm p-6 text-left hover:shadow-md transition-shadow"
          >
            <div className="w-12 h-12 bg-[#FF6B6B] bg-opacity-10 rounded-xl flex items-center justify-center mb-4">
              <Activity className="w-6 h-6 text-[#FF6B6B]" />
            </div>
            <h2 className="text-lg font-semibold text-[#212121] mb-2">System Monitor</h2>
            <p className="text-sm text-gray-600">
              Monitor WhatsApp message recovery system health and performance
            </p>
          </button>
        </div>

        {/* Quick Stats */}
        <div className="mt-8 bg-white rounded-2xl shadow-sm p-6">
          <h3 className="text-base font-semibold text-[#212121] mb-4">System Overview</h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div>
              <p className="text-2xl font-bold text-[#5B8E87]">-</p>
              <p className="text-sm text-gray-600">Total Users</p>
            </div>
            <div>
              <p className="text-2xl font-bold text-[#4ECDC4]">-</p>
              <p className="text-sm text-gray-600">Admins</p>
            </div>
            <div>
              <p className="text-2xl font-bold text-[#FF6B6B]">-</p>
              <p className="text-sm text-gray-600">Practitioners</p>
            </div>
            <div>
              <p className="text-2xl font-bold text-[#AA96DA]">6</p>
              <p className="text-sm text-gray-600">Professions</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
